import { render, staticRenderFns } from "./BillDetailEx.vue?vue&type=template&id=1425f73f&scoped=true"
import script from "./BillDetailEx.vue?vue&type=script&lang=js"
export * from "./BillDetailEx.vue?vue&type=script&lang=js"
import style0 from "./BillDetailEx.vue?vue&type=style&index=0&id=1425f73f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425f73f",
  null
  
)

export default component.exports